import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { RTL_LNGS } from "@/i18n";

/**
 * Phase 7B — Applies the right RTL/LTR direction + `lang` attribute on
 * <html> whenever the i18next language changes. Also toggles a global
 * `.is-rtl` class so utility styles can mirror padding/margins where
 * Tailwind's logical properties are not enough.
 *
 * Mounted once at the top of <App />.
 */
export default function RTLController() {
    const { i18n } = useTranslation();

    useEffect(() => {
        if (typeof document === "undefined") return;
        const raw = (i18n.language || "en");
        const short = raw.split("-")[0];
        // zh-CN is the only 5-char code we keep intact for html lang
        const htmlLang = raw === "zh-CN" ? "zh-CN" : short;
        const isRTL = RTL_LNGS.includes(short) || RTL_LNGS.includes(raw);
        const html = document.documentElement;
        html.setAttribute("lang", htmlLang);
        html.setAttribute("dir", isRTL ? "rtl" : "ltr");
        if (isRTL) html.classList.add("is-rtl");
        else html.classList.remove("is-rtl");
    }, [i18n.language]);

    return null;
}
